import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { RateioEnergiaComponent } from './rateio-energia.component';
import { RateioEnergiaEditComponent } from './rateio-energia-edit/rateio-energia-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [RateioEnergiaComponent, RateioEnergiaEditComponent]
})
export class RateioEnergiaModule { }
